<template>
  <v-dialog v-model="error" width="500">
    <v-card color="white">
      <v-card-title class="headline" primary-title :style="{'color':mainColor}">
        <v-layout justify-center align-content-center>We're Sorry</v-layout>
      </v-card-title>
      <span>
        Your request cannot be completed at this time. Please contact us at
        <a
          href="mailto:ESD_SofNM@globe.life"
          style="text-decoration:none;"
        >ESD_SofNM@globe.life</a> for help.
      </span>
      <br />
      <br />
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: { mainColor: String, value: Boolean },
  created() {
    // console.log('in error dialog')
  },

  computed: {
    error: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>